/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum TooltipIconSizeEnum {
    SMALL = 'SMALL',
    MEDIUM = 'MEDIUM'
}
